import { Injectable, inject } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    Router,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { EnvironmentService } from '@core/services/environment.service';
import { UserService } from '@features/user/services/user.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class IsStaffGuard {
    private userService = inject(UserService);
    private router = inject(Router);
    private environmentService = inject(EnvironmentService);

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        // Shell prerendering: auth resolves in the browser only.
        if (this.environmentService.isServer()) {
            return true;
        }
        return this.userService
            .isStaff()
            .pipe(
                map((isStaff: boolean) =>
                    isStaff ? isStaff : this.router.parseUrl('/dashboard')
                )
            );
    }
}
